import React from 'react';
import _ from 'lodash'
import Divider from 'material-ui/Divider';
import LinearProgress from 'material-ui/LinearProgress';
import * as colors from 'material-ui/styles/colors';
import * as commons from '../commons';

const YosanLinear = ({budget, result}) => {

  let linear
  if (budget != 0) {
    linear = result / budget * 100
  } else {
    linear == 0
  }

  return (
    <div className="row" style={{ marginBottom: 20, display: 'flex', justifyContent: 'flex-end' }}>
      <div className="col-8">
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <div style={{ width: '30%' }}>
            <span style={{ color: colors.grey600 }}>実績 / 予算</span>
            <Divider />
          </div>
          <div style={{ width: '70%', textAlign: 'right' }}>
            <span style={
              {
                fontSize: 27,
                fontWeight: 'lighter',
                color: linear > 100 ? colors.red400 : colors.grey600
              }}>
              {commons.dispMoney(result)}
            </span>
            <span style={{ fontSize: 18, color: colors.grey600 }}>&nbsp;/&nbsp;</span>
            <span style={{ fontSize: 18, color: colors.grey600 }}>{commons.dispMoney(budget)}</span>
            <LinearProgress
              color={linear > 100 ? colors.red400 : colors.blue700}
              mode="determinate" value={linear} />
          </div>
        </div>
      </div>

    </div>
  )

}

export default YosanLinear


// WEBPACK FOOTER //
// ./src/components/YosanLeaner2.js